// Folder links for "View All" functionality
export const folderLinks = {
  shortFormEdits: "https://drive.google.com/drive/folders/1rpsEctlFC1fhBX-n28FU6CuWxGXqFOSh",
  reelsTiktoks: "https://www.dropbox.com/scl/fo/2xoof6h8131dbzdv7luww/h?rlkey=g5rymfh0hon8e1s73v1e9up6l&dl=0",
  aiGenerated: "https://drive.google.com/drive/folders/1MwIFRFtv1z4P43IohW4jMdSsobFwogVg"
};
